/** @jsx jsx */
import { jsx } from '@emotion/core';

import Widget from 'components/pages/Content/Widget';
import { StyledDesktopContainer } from './styles';
import { WidgetsType } from '../../types';

export const WidgetDoubleFreeDesktop = ({
  widgets,
}: {
  widgets: [WidgetsType, WidgetsType];
}): JSX.Element => {
  return (
    <StyledDesktopContainer>
      {widgets.map((widget) => {
        return <Widget widget={widget} isDisplayOnWidgetDouble />;
      })}
    </StyledDesktopContainer>
  );
};
